import React, { useEffect, useState } from 'react';
import { TopBar } from './TopBar';
import { Logo } from './Logo';
import { DesktopMenu } from './DesktopMenu';
import { MobileMenu } from './MobileMenu';
import { Search } from './Search';
import { Account } from './Account';
import { Cart } from './Cart';
/**
 * Header orchestrator. Composes the logical sections:
 *  - <TopBar> utility strip
 *  - <Logo> brand
 *  - <DesktopMenu> primary nav (lg+)
 *  - <Search> / <Account> / <Cart> icon cluster (lg+)
 *  - <MobileMenu> hamburger trigger + slide-down panel (< lg)
 */
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-2' : 'bg-white py-4 border-b border-gray-100'}`} data-id="element-77">
      <TopBar data-id="element-78" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-79">
        <div className="flex justify-between items-center h-16" data-id="element-80">
          <Logo data-id="element-81" />
          <DesktopMenu data-id="element-82" />

          {/* Desktop icon cluster */}
          <div className="hidden lg:flex items-center space-x-6" data-id="element-83">
            <Search data-id="element-84" />
            <Account data-id="element-85" />
            <Cart data-id="element-86" />
          </div>

          {/* Mobile cart + hamburger trigger (panel renders below) */}
          <MobileMenu data-id="element-87" />
        </div>
      </div>
    </header>;
}